<template>
  <div class="filter-save-btn">
    <a-dropdown :disabled="disabled">
      <template #overlay>
        <a-menu class="menu-container" @click="handleMenuClick">
          <a-menu-item key="add" :disabled="addViewBtnDisable">
            <Tooltips v-if="addViewBtnDisable" :showIcon="true" :content="`最多支持创建${viewCustomCountMax}个视图`">
              <div>保存新视图</div>
            </Tooltips>
            <div v-else  class="handle-menu-item">保存新视图</div>
          </a-menu-item>
          <a-menu-item key="updata" v-if="!isSysView">
            <div class="handle-menu-item">更新当前视图</div>
          </a-menu-item>
        </a-menu>
      </template>
      <div class="filter-view-title" :class="{ 'filter-view-title-disabled': disabled }">
        <span class="custom-icon-save icon-save"></span>
        <span>保存视图</span>
      </div>
    </a-dropdown>
    <FilterSaveModal v-if="showSaveModal" :visible="showSaveModal" :viewData="viewData" @confirm="confirmHandel" @cancel="cancelHandel"></FilterSaveModal>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { Tooltips } from '/@/components/Tooltips';
import FilterSaveModal from '/@/components/FusionFilter/src/components/filterSaveModal.vue';
import { updateMenuViewsApi } from '/@/components/ViewMenu/src/api';
import { useMessage } from '/@/hooks/web/useMessage';
import { emitMenuViewUpdateChange } from '/@/components/ViewMenu/src/config';

const props = defineProps({
  viewMenuData: {
    type: Object,
    default: () => []
  },
});

const { createMessage } = useMessage();

/**
 * 数组格式化
 * @param { Array } 需要格式化的数组
 * @returns { Array } 返回格式化后的数组
 */
const keys = ['field', 'javaType', 'rule', 'htmlType', 'val', 'sort']
const arrayFormat = (arr) => {
  return arr.map(item => {
    return keys.reduce((acc, key) => {
      acc[key] = item[key] ?? null; // 处理可能为 undefined 的情况
      return acc;
    }, {});
  })
}
/**
 * 数组比较
 * @param { Array } 需要比较的数组1
 * @param { Array } 需要比较的数组2
 * @returns { Boolean } 返回比较结果
 */
const arraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  const counter1 = arrayFormat(arr1)  
  const counter2 = arrayFormat(arr2)
  return JSON.stringify(counter1) === JSON.stringify(counter2);
} 

// 禁用保存视图按钮 视图配置和默认配置相同
const disabled = computed(() => {
  const filterConfig = props.viewMenuData?.selectedMenu?.viewConfig?.filterConfig ?? []
  const restoreConfig = props.viewMenuData?.restoreConfig ?? []
  return arraysEqual(filterConfig, restoreConfig);
});
// 是否是系统视图
const isSysView = computed(() => {
  return props.viewMenuData?.selectedMenu?.type == 'sys';
});
// 是否禁用保存新视图按钮 1. 视图自定义数量大于等于最大数量 2. 最大数量为0
const addViewBtnDisable = computed(() => {
  const viewCustomCountMax = props.viewMenuData?.viewCustomCountMax ?? 0
  const viewCustomCount = props.viewMenuData?.viewCustomCount ?? 0
  return viewCustomCountMax > 0 ? viewCustomCount >= viewCustomCountMax : false
});

const viewCustomCountMax = computed(() => {
  return props.viewMenuData?.viewCustomCountMax ?? 0
});


const showSaveModal = ref(false)
const viewData = ref({})
// 保存视图点击事件 key: add-新增 updata-更新
const handleMenuClick = (e) => {
  viewData.value = {
    menuId:  props.viewMenuData.filterType,
    type: "private",
    viewConfig: {
      orderConfig: props.viewMenuData.orderConfig,
      columnConfig: props.viewMenuData.columnConfig,
      filterConfig: props.viewMenuData.restoreConfig,
      searchConfig: props.viewMenuData.searchConfig,
    }
  }
  if (e.key == 'add') {
    showSaveModal.value = true
  } else {
    updateMenuViews()
  }
}
// 更新视图
const updateMenuViews = () => {
  const params = {
    id:  props.viewMenuData.selectedMenu.id,
    viewConfig: {
      orderConfig: props.viewMenuData.orderConfig,
      columnConfig: props.viewMenuData.columnConfig,
      filterConfig: props.viewMenuData.restoreConfig,
      searchConfig: props.viewMenuData.searchConfig,
    }
  }

  updateMenuViewsApi(params).then(res => {
    createMessage.success('视图更新成功');
    emitMenuViewUpdateChange({type: 'update', data: params})
  })
}

const confirmHandel = () => {
  showSaveModal.value = false
}

const cancelHandel = () => {
  showSaveModal.value = false
}

</script>

<style lang="less" scoped>
.filter-save-btn {
  display: inline-block;
}

.icon-save {
  font-size: 14px;
  margin-right: 6px;
}
.filter-view-title {
  height: 32px;
  font-size: 14px;
  line-height: 14px;
  padding: 9px 12px;
  margin-bottom: 0;
  color: #262626;
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    color: #2c68ff;
    background-color: #f5f5f5;
  }
}
.filter-view-title-disabled {
  color: #999;
  cursor: not-allowed;
  &:hover {
    color: #999;
    background-color: #fff;
  }
}

.menu-container {
  padding: 12px 0;
}
.handle-menu-item {
  color: #666666;
}


</style>
